import PropTypes from 'prop-types';
import { Col, Row } from 'forkedlibraries/react-bootstrap';
import { MoveOutOptions } from 'models/enums';
import { RENTAL_STATUS_TEXT } from 'strings/rental-status';
import Space from 'corecomponents/Space/Space';
import Condition from 'formcomponents/Condition/Condition';
import String from 'components/String/String';
import GreenInfoBox from 'components/GreenInfoBox/GreenInfoBox';

export const MoveOutNotSureFields = ({ name }) => (
  <Condition is={MoveOutOptions.NotSure} when={`${name}.moveoutOption`}>
    <Row>
      <Col xs={12}>
        <Space />
        <GreenInfoBox>
          <String string={RENTAL_STATUS_TEXT.notSureNote} />
        </GreenInfoBox>
      </Col>
    </Row>
  </Condition>
);

MoveOutNotSureFields.propTypes = {
  name: PropTypes.string.isRequired,
};
